// src/router.js
import { createRouter, createWebHistory } from 'vue-router'

// ===== Layouts (header + <router-view/>) =====
import LayoutES from '@/components/layouts/LayoutES.vue'
import LayoutEN from '@/components/layouts/LayoutEN.vue'

// ===== Pages =====
// ES
import LandingES from '@/components/pages/es/LandingES.vue'
const ContactES = () => import('@/components/pages/es/contactanosES.vue')
const presentacion = () => import('@/components/pages/es/presentacion.vue')


// EN
import LandingEN from '@/components/pages/en/LandingEN.vue'
const ContactEN = () => import('@/components/pages/en/contactanosEN.vue')

const routes = [
  // ====== ES ======
  {
    path: '/',
    component: LayoutES,                // el header ES vive aquí
    children: [
      { path: '', name: 'home-es', component: LandingES },
      { path: 'contactanos', name: 'contacto-es', component: ContactES },
            { path: 'presentacion', name: 'presentacion', component: presentacion },

    ],
  },

  // ====== EN ======
  {
    path: '/en',
    component: LayoutEN,                // el header EN vive aquí
    children: [
      { path: '', name: 'home-en', component: LandingEN },
      { path: 'contact', name: 'contact-en', component: ContactEN },
    ],
  },

  // Fallbacks
  { path: '/en/:pathMatch(.*)*', redirect: '/en' },
  { path: '/:pathMatch(.*)*',    redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Scroll suave a secciones con hash (#perfil, #services, etc.)
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  },
})

export default router
